/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FeatureFlagsResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'FeatureFlags',
        isRequired: true,
      },
    },
  }],
} as const;
